var map = {
	"./Classic Template/Menu": [
		9997,
		607,
		871,
		332,
		997
	],
	"./Classic Template/Menu/Menu": [
		3039,
		607,
		871,
		811
	],
	"./Pizza Restaurant/Menu": [
		950,
		871,
		664,
		736,
		950
	],
	"./Pizza Restaurant/Menu/Menu": [
		3856,
		871,
		664,
		736,
		475
	],
	"./Sushi Restaurant/Menu": [
		9910,
		607,
		871,
		160,
		910
	],
	"./Sushi Restaurant/Menu/Menu": [
		8432,
		607,
		871,
		402
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1762;
module.exports = webpackAsyncContext;